import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
const mesLogo = process.env.PUBLIC_URL + "/mes-logo.png";

export default function TopHeader({ title, subtitle, right }) {
    const { user, logout } = useAuth();
    return (
        <header
            data-testid="top-header"
            className="sticky top-0 z-30 border-b border-mes-border bg-white/95 backdrop-blur"
        >
            <div className="mx-auto flex max-w-2xl items-center justify-between gap-3 px-4 py-3">
                <div className="flex min-w-0 items-center gap-3">
                    <img
                        data-testid="logo-slot"
                        src={mesLogo}
                        alt="MES – My Easy Solar"
                        className="block shrink-0"
                        style={{ maxHeight: 32, maxWidth: 140, height: "auto", width: "auto", objectFit: "contain" }}
                    />
                    <div className="min-w-0 leading-tight">
                        <div className="truncate font-display text-[15px] font-bold text-mes-ink" data-testid="top-header-title">
                            {title}
                        </div>
                        {subtitle && (
                            <div className="truncate text-[11px] text-mes-muted">{subtitle}</div>
                        )}
                    </div>
                </div>
                <div className="flex shrink-0 items-center gap-2">
                    {right}
                    <div className="hidden text-right sm:block">
                        <div className="text-[11px] text-mes-muted">Angemeldet</div>
                        <div className="text-[13px] font-semibold text-mes-ink">{user?.name}</div>
                    </div>
                    <Button
                        data-testid="btn-logout"
                        variant="ghost"
                        size="icon"
                        onClick={logout}
                        className="h-9 w-9 text-mes-muted hover:bg-mes-surfaceAlt hover:text-mes-ink"
                        title="Abmelden"
                    >
                        <LogOut className="h-4 w-4" strokeWidth={2} />
                    </Button>
                </div>
            </div>
        </header>
    );
}
